import { useEffect, useState, useLayoutEffect, useRef } from "react";
const ModalBody = ({ children }) => {
  return (
    <div style={{ padding: '20px' }}>
      {children}
    </div>
  );
};


export default ModalBody;
